/*!

=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim 

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* create notice list

*/
import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// control session
import Session from "module/session/Session";
// module refund 
import Refund from "module/refund/Refund";
// module pay 
import Pay from "module/pay/Pay";
// Funding class 생성
import Funding from "module/funding/Funding";
// Ticket class 생성
import Ticket from "module/ticket/Ticket";
// User class 생성
import User from "module/user/User";

// reactstrap components
import {
  Button,
  Card,
  Label,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  FormGroup,
  Form,
  Input,
  Row,
  Col
} from "reactstrap";

function RefundView() {

  const [data, setData] = useState([]);
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState('');
  const [contestantId, setContestantId] = useState('');

  var pageSize = 1000;
  var page = 1;

  const queryParameters = new URLSearchParams(window.location.search)
  const refundId = queryParameters.get("refundId")

  const sessionInfo = Session.getSession();

  const NICE_BANK_CODE = [{ value: "001", label: "한국은행" }, { value: "002", label: "산업은행" }, { value: "003", label: "기업은행" }, { value: "004", label: "국민은행" }, { value: "007", label: "수협은행" }, { value: "008", label: "수출입은행" }, { value: "011", label: "NH농협은행" }, { value: "012", label: "농축협" }, { value: "020", label: "우리은행" }, { value: "023", label: "SC제일은행" }, { value: "027", label: "한국씨티은행" }, { value: "031", label: "대구은행" }, { value: "032", label: "부산은행" }, { value: "034", label: "광주은행" }, { value: "035", label: "제주은행" }, { value: "037", label: "전북은행" }, { value: "039", label: "경남은행" }, { value: "041", label: "우리카드" }, { value: "045", label: "새마을금고" }, { value: "048", label: "신협" }, { value: "050", label: "저축은행" }, { value: "052", label: "모간스탠리은행" }, { value: "054", label: "HSBC은행" }, { value: "055", label: "도이치은행" }, { value: "057", label: "제이피모간체이스은행" }, { value: "058", label: "미즈호은행" }, { value: "059", label: "엠유에프지은행" }, { value: "060", label: "BOA은행" }, { value: "061", label: "비엔피파리바은행" }, { value: "062", label: "중국공상은행" }, { value: "063", label: "중국은행" }, { value: "064", label: "산림조합중앙회" }, { value: "065", label: "대화은행" }, { value: "066", label: "교통은행" }, { value: "067", label: "중국건설은행" }, { value: "071", label: "우체국" }, { value: "076", label: "신용보증기금" }, { value: "077", label: "기술보증기금" }, { value: "081", label: "하나은행" }, { value: "088", label: "신한은행" }, { value: "089", label: "케이뱅크" }, { value: "090", label: "카카오뱅크" }, { value: "092", label: "토스뱅크" }, { value: "094", label: "서울보증보험" }, { value: "101", label: "한국신용정보원" }, { value: "209", label: "유안타증권" }, { value: "218", label: "KB증권" }, { value: "221", label: "상상인증권" }, { value: "222", label: "한양증권" }, { value: "223", label: "리딩투자증권" }, { value: "224", label: "BNK투자증권" }, { value: "225", label: "IBK투자증권" }, { value: "227", label: "다올투자증권" }, { value: "238", label: "미래에셋증권" }, { value: "240", label: "삼성증권" }, { value: "243", label: "한국투자증권" }, { value: "247", label: "NH투자증권" }, { value: "261", label: "교보증권" }, { value: "262", label: "하이투자증권" }, { value: "263", label: "현대차증권" }, { value: "264", label: "키움증권" }, { value: "265", label: "이베스트투자증권" }, { value: "266", label: "SK증권" }, { value: "267", label: "대신증권" }, { value: "269", label: "한화투자증권" }, { value: "270", label: "하나증권" }, { value: "271", label: "토스증권" }, { value: "272", label: "NH선물" }, { value: "273", label: "코리아에셋투자증권" }, { value: "274", label: "DS투자증권" }, { value: "275", label: "흥국증권" }, { value: "278", label: "신한투자증권" }, { value: "279", label: "DB금융투자" }, { value: "280", label: "유진투자증권" }];

  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hour = String(now.getHours()).padStart(2, '0');
  const minute = String(now.getMinutes()).padStart(2, '0');
  const second = String(now.getSeconds()).padStart(2, '0');
  // const formattedDateTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  const formattedDateTime = now.toISOString().replace('Z', '');


  //refund class
  let refund = new Refund(process.env.REACT_APP_REFUNDAPI, {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
    'Authorization_Access': sessionInfo.token
  });

  //pay class
  let pay = new Pay(process.env.REACT_APP_PAYAPI, {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
    'Authorization_Access': sessionInfo.token
  });

  let funding = new Funding(process.env.REACT_APP_FUNDINGAPI, {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
    'Authorization_Access': sessionInfo.token
  });

  let ticket = new Ticket(process.env.REACT_APP_TICKETAPI, {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
    'Authorization_Access': sessionInfo.token
  });

  let user = new User(process.env.REACT_APP_USERAPI, {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
    'Authorization_Access': sessionInfo.token
  });

  const state = {
    "CD": "구매취소",
    "O1": "구매신청",
    "O2": "승인보류",
    "OD": "승인완료",
    "R1": "환불신청",
    "R2": "환불보류",
    "RD": "환불완료",
    "OF": "결제실패"
  };

  useEffect(() => {
    if (refundId != '' && refundId != null) {
      getData();
    }
  }, [])

  const getData = async () => {
    var result = await refund.findOne('refundId=' + refundId)

    if (result.data.data) {
      var param = "payId=" + result.data.data.payId;
      var response = await pay.findOne(param);

      if (response.data.data) {
        result.data.data.payData = response.data.data;
      }

      var param = "ticketId=" + result.data.data.ticketId;
      var response = await ticket.findOne(param);

      if (response.data.data) {
        result.data.data.ticketData = response.data.data;
      }

      var param = "userId=" + result.data.data.memberId;
      var response = await user.findOne(param);

      if (response.data.data) {
        result.data.data.userData = response.data.data;
      }

      setData(result.data.data);
    }

  }

  //상태값 업데이트 하기 
  const updateState = async () => {

    if (document.getElementById('changeState').value != '') {
      var result = await refund.update('?refundId=' + refundId, {
        refundId: refundId,
        payId: document.getElementById('payId_' + refundId).value,
        ticketAmount: document.getElementById('ticketAmount_' + refundId).value,
        totalAmount: document.getElementById('totalAmount_' + refundId).value,
        ticketCount: document.getElementById('ticketCount_' + refundId).value,
        ticketId: document.getElementById('ticketId_' + refundId).value,
        memberId: document.getElementById('memberId_' + refundId).value,
        createdAt: document.getElementById('createdAt_' + refundId).value,
        deletedAt: document.getElementById('deletedAt_' + refundId).value,
        updatedAt: formattedDateTime,
        status: document.getElementById('changeState').value
      })
    }

    if (result.data.code == 200) {

      var result = await pay.update('?payId=' + data.payId, {
        payId: data.payId,
        fundingId: data.payData.fundingId,
        ticketAmount: data.payData.ticketAmount,
        totalAmount: data.payData.totalAmount,
        ticketCount: data.payData.ticketCount,
        private: data.payData.private,
        ticketId: data.payData.ticketId,
        memberId: data.payData.memberId,
        createdAt: data.payData.createdAt,
        updatedAt: formattedDateTime,
        deletedAt: data.payData.deletedAt,
        confirmationAt: data.payData.confirmationAt,
        status: document.getElementById('changeState').value
      })

      alert('결제상태 변경을 완료 하였습니다.');
      window.location.reload();

    } else {
      alert('유형 변경에 실패 하였습니다.');
    }
  }


  return (
    <>
      <div className="content">
        <Row>
          <Col md="12" lg="12">
            <Card>
              <CardHeader>
                <h3 className="Category">환불 정보</h3>
                {console.log(data)}
              </CardHeader>
              <CardBody>
                <Form>
                  <Input defaultValue={data.payId} type="hidden" id={`payId_` + data.refundId} />
                  <Input defaultValue={data.ticketId} type="hidden" id={`ticketId_` + data.refundId} />
                  <Input defaultValue={data.ticketAmount} type="hidden" id={`ticketAmount_` + data.refundId} />
                  <Input defaultValue={data.totalAmount} type="hidden" id={`totalAmount_` + data.refundId} />
                  <Input defaultValue={data.ticketCount} type="hidden" id={`ticketCount_` + data.refundId} />
                  <Input defaultValue={data.memberId} type="hidden" id={`memberId_` + data.refundId} />
                  <Input defaultValue={data.createdAt} type="hidden" id={`createdAt_` + data.refundId} />
                  <Input defaultValue={data.updatedAt} type="hidden" id={`updatedAt_` + data.refundId} />
                  <Input defaultValue={data.deletedAt} type="hidden" id={`deletedAt_` + data.refundId} />
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>주문번호</label>
                    <p>{data.payId ? data.payId : ''}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>카테고리</label>
                    <p>{data.fundingData ? data.fundingData.categoryCode : 'P01_01_01'}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>티켓명</label>
                    <p>{data.ticketData ? data.ticketData.ticketName : '티켓'}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>티켓유형</label>
                    <p>{data.ticketData ? (data.ticketData.type == 'CONTENT' ? '콘텐츠 제작 티켓' : '밈카드 제작 티켓') : '밈카드 제작 티켓'}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>티켓금액</label>
                    <p>{data.ticketAmount ? data.ticketAmount : 0}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>티켓갯수</label>
                    <p>{data.ticketCount ? data.ticketCount : 0}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>결제상태</label>
                    <p>{data.status ? state[data.status] : '구매요청'}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>결제유형</label>
                    <p>{data.private ? '프라이빗' : '퍼블릭'}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>구매자아이디</label>
                    <p>{data.userData ? data.userData.email : ''}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>닉네임</label>
                    <p>{data.userData ? data.userData.nickName : ''}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>은행명</label>
                    <p>
                      {(data.userData && data.userData.bankName) &&
                        NICE_BANK_CODE.map((option, index) => {
                          if (option.value === data.userData.bankName) {
                            return <p>{option.label}</p>
                          }
                        })}
                    </p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>계좌번호</label>
                    <p>{data.userData ? (data.userData.bankAccount ?? '없음') : ''}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>예금주명</label>
                    <p>{data.userData ? (data.userData.accountHolderName ?? '없음') : ''}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>총 구매금액</label>
                    <p>{data.totalAmount ? data.totalAmount : 0}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>구매일</label>
                    <p>{data.createdAt ? data.createdAt : ''}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>승인일</label>
                    <p>{data.confirmationAt ? data.confirmationAt : ''}</p>
                  </Col>
                  <Col className="pr-md-1 titleAdmin d-inline-block" md="6">
                    <label>삭제일</label>
                    <p>{data.deletedAt ? data.deletedAt : ''}</p>
                  </Col>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <span>
          선택된 결제상태
          <FormGroup check style={{ display: "inline-block", marginRight: "5px" }}>
            <Label check>
              <Input type="select" name="changeState" id="changeState" onChange={updateState}>
                <option value="">환불상태</option>
                <option value="R1">환불신청</option>
                <option value="R2">환불보류</option>
                <option value="RD">환불완료</option>
              </Input>
            </Label>
          </FormGroup>
          으로 변경
        </span>
      </div>
    </>
  );
}

export default RefundView;
